import type { ReactNode } from 'react'

export interface DonutProps {
  readonly value: number
  readonly max?: number
  readonly size?: number
  readonly stroke?: number
  readonly color?: string
  readonly trackColor?: string
  readonly label?: ReactNode
}

export function Donut({
  value,
  max = 100,
  size = 64,
  stroke = 8,
  color = 'var(--brand)',
  trackColor = 'var(--bg-muted)',
  label,
}: DonutProps) {
  const radius = (size - stroke) / 2
  const circumference = 2 * Math.PI * radius
  const pct = Math.max(0, Math.min(1, value / max))
  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} aria-hidden="true">
        <circle cx={size / 2} cy={size / 2} r={radius} stroke={trackColor} strokeWidth={stroke} fill="none" />
        <circle
          data-part="value"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={stroke}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - pct)}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: 'stroke-dashoffset 500ms ease' }}
        />
      </svg>
      {label !== undefined ? (
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', lineHeight: 1 }}>
          {label}
        </div>
      ) : null}
    </div>
  )
}
